import requester from 'utils/requester';
import api from 'config/api';
import { IRequesterResponse, DetailsObjectType } from './loader-types';

export const FAVORITES = 'FAVORITES' as const;
export const HISTORY = 'HISTORY' as const;
export const RECORDED = 'RECORDED' as const;

const tabs = [
  { id: FAVORITES, name: 'Favorites', loginRequired: true },
  {
    id: HISTORY,
    name: 'History',
    loginRequired: true,
  } /*
  { id: RECORDED, name: 'Recorded', loginRequired: true },*/,
];

const paramsByTabType = {
  [FAVORITES]: {
    'type[in]': 'movie,series',
    $expand: 'resources(url),entitlement,bookmark',
    'favorite[eq]': 1,
    $orderby: 'favorite',
    $limit: 10,
  },
  [HISTORY]: {
    'type[in]': 'movie',
    $expand: 'resources(url),entitlement,bookmark',
    'bookmark[eq]': 1,
    $orderby: 'bookmark_update_time',
    $limit: 10,
  },
  [RECORDED]: {
    'state[eq]': 'recorded',
    $expand: '*',
    $limit: 10,
  },
};

const loadFavorites = async ({ offset, tabId }) => {
  const $offset = Number.isInteger(offset) ? offset : 0;

  const params = paramsByTabType[tabId];

  if (!params) return { content: [] };

  const endpoint = api.endpoints[tabId === RECORDED ? 'dvrTasks' : 'assets'];

  const { data: content } = (await requester({
    method: 'get',
    url: `${api.host}${endpoint}`,
    params: {
      ...params,
      $offset,
    },
  })) as IRequesterResponse<DetailsObjectType[]>;

  return { content, offset: $offset };
};

export const myWatchlistPageLoader = async (params) => {
  // tab content
  if (params.tabId) {
    return await loadFavorites(params);
  }

  const name = 'My List';

  return { name, tabs };
};

export default myWatchlistPageLoader;
